export const DEFAULT_KOPY_PAGES_PRODUCT_CURRENCY = "USD"

export const hasEnoughKopyPagesImages = (product) => {
	if (!product) return false

	return (
		product?.images?.filter((image) => {
			return Boolean(image?.src)
		})?.length >= 2
	)
}

export const loadKopyPagesProductResult = async ({
	result,
	getMetafieldsAndUpdatePreview,
	setFetchedProduct,
	setFetchedProductCurrency,
	setProductUrl,
	setLoading,
	setProgress,
	setUploadError,
	t,
}) => {
	const product = result?.product || null

	if (!product) {
		setLoading(false)
		setProgress(null)
		setUploadError(t("single.fetch_error"))
		return false
	}

	const currency = result?.currency || DEFAULT_KOPY_PAGES_PRODUCT_CURRENCY

	setFetchedProduct(product)
	setFetchedProductCurrency(currency)

	if (result?.productUrl) {
		setProductUrl(result.productUrl)
	}

	if (!hasEnoughKopyPagesImages(product)) {
		setLoading(false)
		setProgress(null)
		setUploadError(t("kopy_pages.not_enough_images_error"))
		return false
	}

	await getMetafieldsAndUpdatePreview({
		product,
		currency,
	})

	return true
}
